import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import { Form } from "../../../components/form/DynamicFormTs";
import { withRouter } from "react-router-dom";
import Http from "../../../Http";
import { CircularProgress, Chip } from "@material-ui/core";

class InformacionGuia extends FormComponent {
  initial = true;

  componentDidMount() {
    let fields = [
      Form.Field(
        "text",
        "g_folio",
        "Folio",
        "",
        [],
        12,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Field(
        "text",
        "g_estado_descripcion",
        "Estatus",
        "",
        [],
        12,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Field(
        "text",
        "g_pedido_remision_manifiesto",
        "Pedido / Remisión / Manifiesto",
        "",
        [],
        12,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Section("Remitente"),
      Form.Field(
        "text",
        "remitente",
        "Remitente",
        "",
        [],
        6,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Field(
        "text",
        "remitente_domicilio",
        "Remitente Domicilo",
        "",
        [],
        6,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Field(
        "text",
        "remitente_colonia",
        "Remitente Colonia",
        "",
        [],
        6,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Field(
        "text",
        "remitente_estado",
        "Remitente Estado",
        "",
        [],
        6,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Section("Destinatario"),
      Form.Field(
        "text",
        "destinatario",
        "Destinatario",
        "",
        [],
        6,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Field(
        "text",
        "destinatario_domicilio",
        "Destinatario Domicilo",
        "",
        [],
        6,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Field(
        "text",
        "destinatario_colonia",
        "Destinatario Colonia",
        "",
        [],
        6,
        [],
        [],
        [],
        false,
        true
      ),
      Form.Field(
        "text",
        "destinatario_estado",
        "Destinatario Estado",
        "",
        [],
        6,
        [],
        [],
        [],
        false,
        true
      ),
    ];
    this.FormConfig(
      {
        defaultUrl: "guia/info",
        saveUrl: "banco/save",
        backUrl: "/Guias/SeguimientoGuias",
      },
      new Form(fields, [], ""),
      this.formData
    );
    if (this.props.guia) {
      this.LoadPreds(this.props.guia.id);
    }
  }

  LoadPreds = async (predId = null, callOnChange = true) => {
    let id = predId ? predId : this.props.match.params.id;
    this.setState({ loadingData: true });
    let Res = await Http.get(`guia/info/${id}`);
    if (!Res.error) {
      this.setState({
        FormData: Form.Patch(this.state.FormData, Res.data, callOnChange),
        remisiones: Res.data.remisiones || [],
      });
    }
    this.setState({ loadingData: false });
    return Res.data;
  };

  formData = (form) => {
    return form;
  };

  componentDidUpdate(prevProps) {
    if (prevProps.guia.id !== this.props.guia.id) {
      this.LoadPreds(this.props.guia.id);
    }
  }

  render() {
    const { loadingData = false, remisiones = [] } = this.state;
    return (
      <div>
        {loadingData ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <CircularProgress />
            Cargando
          </div>
        ) : (
          <div>
            <this.FormRender />
            {remisiones && remisiones.length > 0 && (
              <div
                style={{
                  marginTop: 20,
                  padding: 15,
                  border: "1px solid #1976d2",
                  borderRadius: 8,
                  backgroundColor: "#f0f7ff",
                }}
              >
                <h4
                  style={{
                    margin: "0 0 10px 0",
                    color: "#1565c0",
                    fontSize: 15,
                    fontWeight: 600,
                  }}
                >
                  Remisiones Asociadas ({remisiones.length})
                </h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {remisiones.map((r, i) => (
                    <Chip
                      key={i}
                      label={`Remisión: ${r.orden}${
                        r.factura && r.factura !== r.orden
                          ? ` | Fact: ${r.factura}`
                          : ""
                      }${r.unidades ? ` (${r.unidades} pzas)` : ""}`}
                      color="primary"
                      variant="outlined"
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(InformacionGuia);
